var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTilde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 10",
    width: 100,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 2S72 7 47 2 0 4 0 4v6h100V2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTilde);
export default __webpack_public_path__ + "static/media/Tilde.fb821c6d47dcd36b3b7e6bb92fa0406e.svg";
export { ForwardRef as ReactComponent };